import React from 'react';
import { Toaster } from 'react-hot-toast';
import { Portal } from '../Portal/index.js';
export const ToastContainer = () => (React.createElement(Portal, null,
    React.createElement(Toaster, { position: "top-right" })));
//# sourceMappingURL=ToastContainer.js.map